// Landingsheader-CTA.
//
// Label en anker verschillen per landingspagina ("Probeer nu met 20% korting"
// → #offer, "Bekijk alle visolie" → #aanbod). De header is één gedeelde sectie
// en kan de instellingen van de hero-sectie niet lezen, dus nemen we ze hier
// over van de hero-knop zelf. Scheelt een tweede instelling per LP die uit
// elkaar kan gaan lopen.
//
// Zonder hero-knop blijft de header-knop verborgen (hij heeft dan geen doel).

function syncLandingCta() {
  const heroButton = document.querySelector('.ab-lp-hero__btn a');
  const cta = document.querySelector('.header__lp-cta');

  if (!heroButton || !cta) return;

  cta.textContent = heroButton.textContent.trim();
  cta.href = heroButton.getAttribute('href');
  cta.classList.add('is-ready');
}

syncLandingCta();

// Bij een sectie-herrender (theme-editor, `shopify theme dev`) wordt de header
// opnieuw in de DOM gezet — met een lege knop, terwijl deze module niet nog een
// keer draait. Zonder deze listener verdwijnt de knop dan tot de volgende
// volledige herlaad. Geldt ook andersom: verandert de hero-knop, dan volgt de
// header-knop mee.
document.addEventListener('shopify:section:load', syncLandingCta);
